import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw, RouteLocationNormalized, NavigationGuardNext } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录', requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('@/components/layout/AppLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/home'
      },
      {
        path: 'home',
        name: 'HomePage',
        component: () => import('@/views/home/HomePage.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'employee',
        name: 'EmployeeList',
        component: () => import('@/views/employee/EmployeeList.vue'),
        meta: { title: '员工管理' }
      },
      {
        path: 'group-chat',
        name: 'GroupChatList',
        component: () => import('@/views/groupChat/RegionGroupList.vue'),
        meta: { title: '群聊管理' }
      },
      {
        path: 'submissions',
        name: 'SubmissionList',
        component: () => import('@/views/formSubmission/SubmissionList.vue'),
        meta: { title: '表单数据' }
      },
      {
        path: 'agreement',
        name: 'AgreementEditor',
        component: () => import('@/views/agreement/AgreementEditor.vue'),
        meta: { title: '协议编辑' }
      },
      {
        path: 'manager',
        name: 'ManagerList',
        component: () => import('@/views/manager/ManagerList.vue'),
        meta: { title: '管理员管理' }
      },
      {
        path: 'system',
        name: 'SystemSettings',
        component: () => import('@/views/system/SystemSettings.vue'),
        meta: { title: '系统设置' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// 路由守卫
router.beforeEach((to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const token = localStorage.getItem('token');
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false);
  
  // 设置页面标题
  const title = to.meta.title as string;
  if (title) {
    document.title = `${title} - 管理后台`;
  }
  
  if (requiresAuth && !token) {
    next('/login');
  } else if (to.path === '/login' && token) {
    next('/home');
  } else {
    next();
  }
});

export default router;
